import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMapLibreGLModule } from '@maplibre/ngx-maplibre-gl';
import { ListItemsComponent } from './components/list-items/list-items.component';
import { ListViewComponent } from './components/list-view/list-view.component';
import { ListComponent } from './components/list/list.component';
import { FullPageOverlayComponent, IconComponent } from '@ui/shared/ui-common';
import { FiltersDirective } from './directives/filters.directive';
import { ListItemComponent } from './components/list-item/list-item.component';
import { ListItemsSkeletonComponent } from './components/list-items-skeleton/list-skeleton.component';
import { SkeletonModule } from 'primeng/skeleton';
import { FocusTrapModule } from 'primeng/focustrap';
import { AutoFocusModule } from 'primeng/autofocus';
import { ItemContentDirective } from './directives/item-content.directive';
import { ButtonDirective } from 'primeng/button';

@NgModule({
    declarations: [
        ListItemsComponent,
        ListItemsSkeletonComponent,
        FiltersDirective,
        ItemContentDirective,
        ListViewComponent,
        ListComponent,
        ListItemComponent,
    ],
    imports: [
        CommonModule,

        NgxMapLibreGLModule,
        SkeletonModule,
        FocusTrapModule,
        AutoFocusModule,

        IconComponent,
        FullPageOverlayComponent,
        ButtonDirective,
    ],
    exports: [
        ListViewComponent,
    ],
})
export class ListViewModule {
}
